<mat-icon class="mc-snack-bar-icon mc-self-centered-icon" color="secondary-invert" fontSet="project-titan" fontIcon="icon-error"></mat-icon>
<span matSnackBarLabel>{{ message }}</span>
<button mat-icon-button color="secondary-invert" class="mc-snack-bar-close-button" (click)="close()">
  <mat-icon fontSet="project-titan" fontIcon="icon-close"></mat-icon>
</button>